import { render, staticRenderFns } from "./VipType.vue?vue&type=template&id=6f9c569e&scoped=true&"
import script from "./VipType.vue?vue&type=script&lang=js&"
export * from "./VipType.vue?vue&type=script&lang=js&"
import style0 from "./VipType.vue?vue&type=style&index=0&id=6f9c569e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c569e",
  null
  
)

export default component.exports